var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"editor-widget-wrap relative flex items-center justify-center",class:_vm.getClass},[(_vm.editing)?_c('m-editor',{on:{"input":_vm.onChangeValue},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }